import React, { useContext, useRef } from "react";
import ReactAudioPlayer from "react-audio-player";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import CloseButton from "react-bootstrap/CloseButton";

import {
	Row,
	Col,
	Form,
	FloatingLabel,
	Button,
	Card,
	CardHeader,
	CardBody,
	Modal,
} from "react-bootstrap";
import { FaUser, FaIdCard, FaIdCardAlt } from "react-icons/fa";
import { DivideTitleComponent } from "../../components";
import { useValidation } from "../../context/ValidationContext";
import TinyMCEEditor from "./draft/TextEditorWithTable";
import PageLayout from "../../layouts/PageLayout";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import Persondetails from "./draft/PerosonDetails";
import FamilyDetails from "./draft/FamilyDetails";
import FamilyStory from "./draft/FamilyStory";
import FamilyChildrens from "./draft/FamilyChildrens";
import LoanDetails from "./draft/LoanDetails";
import BusinessDetails from "./draft/BusinessDetails";
import axiosInstance from "../../context/axiosInstance";
import { FaFileInvoice } from "react-icons/fa";
import { BsFillBookFill } from "react-icons/bs";
import axios from "axios";
import Swal from "sweetalert2";
import AddNewBrickKiln from "./BrickKiln/AddNewBrickkiln";
import StoreBrickkiln from "./BrickKiln/StoreBrickkiln";
import microPhoneSvg from "../../assets/images/microphone_svg.svg";
import "./EditDraftStyling.css"
import noImage from "../../assets/images/image.png"

import audio from "../../assets/audio.mp3";

export default function EditDraft() {
	const { fsf_id } = useParams();

	const AuthToken = localStorage.getItem("AuthUser");

	const navigate = useNavigate();
	const [data, setData] = useState({});
	const [errors, setErrors] = useState({});
	const [error, setError] = useState({});
	const [isFocused, setIsFocused] = useState(false);
	const [openImg, setOpenImg] = useState(null);
	const [searchValue, setSearchValue] = useState("");
	const [showModal, setShowModal] = useState(false);

	const [previewUrl, setPreviewUrl] = useState(null); // track clicked image
	const [show, setShow] = useState(false);

	const openImage = (url) => {
		setPreviewUrl(url);
		setShow(true);
	};

	const handleCloseImageModal = () => {
		setShow(false);
	};
	axios.defaults.headers.common[
		"Authorization"
	] = `Bearer ${AuthToken}`;
	// ------------------------------------ Use States ----------------------------------------------
	const [formState, setFormState] = useState({
		peopleId: "",
		identifier_id: "",
		beneficiary_name: "",
		gender_id: "",
		slavery_years: "",
		mob: "",
		cnic: "",
		cnic_expire_date: "",
		dob: "",
		reason: "",
		marital_status_id: "",
		marital_status_name: "",

		slavery_reason_id: "",
		occupation_id: "",
		assessment_date: "", // fixed spelling
		faith_id: "",
		baptised: "",
		city_id: "",
		verification_date: "",
		rescue_date: "",
		present_address: "",
		number_of_work_dependents: "",
		permanent_address: "",
		avatar: { file: null, preview: null, imgsrc: "" },
		cnic_f_img: { file: null, preview: null, imgsrc: "" },
		cnic_b_img: { file: null, preview: null, imgsrc: "" },
		union_council: "",
		name: "",
		// church deatails
		church_name: "",
		pastor_name: "",
		pastor_cell_number: "",
		is_visited_by_pastor: "",
		frequent: "",
		flagged: "",
		live_by_choice: "",
		living_address: null,
		distance_to_home: null,
		transportation: "",
		family_story_video: "",
		/// Family details
		is_parent_dependent: false,
		father_name: "",
		father_cnic: "",
		father_dob: "",
		father_slavry_years: "",
		father_is_dead: false,
		mother_name: "",
		mother_cnic: "",
		mother_dob: "",
		mother_slavry_years: "",
		mother_is_dead: false,
		spouse_name: "",
		spouse_cnic: "",
		spouse_dob: "",
		spouse_slavry_year: "",
		spouse_is_dead: false,
		relationship_id: "",
		kin_list: [],
		worker_list: [],

		/// Family story
		family_story: "",
		extra_comments: "",
		prayer_request: "",
		family_story_audio: "",

		/// Childrens
		no_child: false,
		child: [],
		entered_by: "",
		/// Loan
		loanId: "",
		brick_kiln_id: "",
		loan_type_id: "",
		est_loan_amount: "",
		loan_amount: "",
		medical_amount: "",
		food_ration: "",
		meal_amount: "",
		khatta_amount: "",
		utility_amount: "",
		rent_amount: "",
		other: "",
		affidavit_amount: "",
		//image gallery

		affidavit: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		relocation_img: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		release_img: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		family_check_img: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		family_working_img: {
			file: null,
			preview: null,
			imgsrc: "",
		},

		img_1: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		img_2: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		img_3: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		img_4: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		img_5: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		img_6: {
			file: null,
			preview: null,
			imgsrc: "",
		},
		new_home_img: {
			file: null,
			preview: null,
			imgsrc: "",
		},

		khatta_unpaid_file: {
			file: null,
			preview: null,
			imgsrc: "",
		},

		total_pkr: 0,
		loan_images: [],
		unpaid_loan_invoice: { file: null, preview: null, imgsrc: "" },
		khatta_unpaid_file: { file: null, preview: null, imgsrc: "" },
		enter_by: "",

		number_of_dependents: "",
		live_on_brick_kiln: "",

		/// Acknowledgement
		identifier: {
			id: "",
			user_id: "",
			city_id: "",
			name: "",
			phone: "",
			cnic: "",
			org: "",
			signature: "",
			created_at: "",
			updated_at: "",
		},
		mobilizer: "",
		mobilizer_id: "",
		f_number: "",
		prayer_request: "",
		is_allow_to_meet_relatives: "",
		working_hours: "",
		working_years_on_brick_kiln: "",
		first_loan_amount: "",
		loan_year: "",

		// Feasibility Assesment

		want_to_leave_work: "",
		why: "",
		plans_after_leaving_work: "",
		willing_to_learn_new_skills: "",
		new_skill_or_job: "",
		willing_to_educate_children: "",
		willing_to_pay_in_installments: "",
	});


	const handleOpenImage = (image, index) => {
		setOpenImg({ ...image, index });
	};


	const handleCloseImage = () => {
		setOpenImg(null);
	};
	const handleModalClose = () => setShowModal(false);
	const handleModalShow = () => setShowModal(true);

	const handleStoreModal = (brickkiln) => {
		// Update data to include the new brick kiln
		setData((prevData) => ({
			...prevData,
			brickkilns: [...prevData.brickkilns, brickkiln],
		}));

		// Set the newly added brick kiln as the selected option
		setFormState((prevState) => ({
			...prevState,
			brick_kiln_id: brickkiln.id,
		}));

		setShowModal(false);
	};


	const validateTab1 = () => {
		// const requiredFields = [
		//   "identifier_id",
		//   "beneficiary_name",
		//   "gender_id",
		//   "slavery_years",
		//   "mob",
		//   "cnic",
		//   "dob",
		//   "marital_status_id",
		//   "slavery_reason_id",
		//   "occupation_id",
		//   "abuse_id",
		//   "faith_id",
		//   "city_id",
		//   "verification_date",
		//   "present_address",
		//   "permanent_address",
		//   "union_council",

		// ];

		// if (error?.cnic) {
		//   return false; // Stop further processing if validation fails
		// }
		// for (let field of requiredFields) {
		//   if (!formState[field]) {

		//     return false; // Stop further processing if validation fails
		//   }
		// }
		return true;
	};

	// Validation for Tab 2
	const validateTab4 = () => {
		const requiredFields = ["brick_kiln_id", "loan_type_id"];
		for (let field of requiredFields) {
			if (!formState[field]) {
				return false; // Stop further processing if validation fails
			}
		}
		return true;
	};

	const validateTab5 = () => {
		return true;
	};
	// error messages
	const errorMessages = () => {
		// you can add alert or console.log or any thing you want

		Swal.fire({
			title: "Error!",
			text: "Please fill in the required fields",
			icon: "error",
			confirmButtonText: "Ok",
		});
	};

	const [currentTab, setCurrentTab] = useState(0);

	const tabChanged = ({ prevIndex, nextIndex }) => {
		// console.log("nextIndex", nextIndex);
	};

	const [filteredCities, setFilteredCities] = useState([]);

	const { formatCnic, validateCnic, validateImageDimensions } =
		useValidation();

	const handleSearch = (value) => {
		setSearchValue(value); // Update the input value
		if (value.trim() === "") {
			setFilteredCities([]); // Clear suggestions if input is empty
		} else {
			const filtered = data?.cities?.filter((city) =>
				city.name.toLowerCase().includes(value.toLowerCase())
			);
			setFilteredCities(filtered);
		}
	};

	const handleFileChange = async (e, fieldName, width, height) => {
		const file = e.target.files[0];
		if (file) {
			try {
				// Validate and resize the image
				const resizedImage = await validateImageDimensions(
					file,
					width,
					height
				);
				const previewUrl = URL.createObjectURL(resizedImage);

				setFormState((prevState) => ({
					...prevState,
					[fieldName]: {
						file: resizedImage,
						preview: previewUrl,
					},
				}));
				setError(""); // Clear any previous errors
			} catch (err) {
				setError("Invalid image file or dimensions.");
			}
		}
	};
	const checkCnic = async (value) => {
		try {
			const response = await axios.post(
				process.env.REACT_APP_API_URL + "/check-cnic",
				{
					cnic: value,
				}
			);
			console.log(response.data);
			if (response?.data?.success === false) {
				setError((prevError) => ({
					...prevError,
					cnic: response?.data?.message?.cnic,
				}));
			}
		} catch (error) {
			console.error("Error Posting Data", error);
		}
	};

	const createFormData = (data) => {
		console.log("Data passed to createFormData:", data);
		const apiformData = new FormData();

		Object.keys(data).forEach((key) => {
			const value = data[key];
			if (key === "family_story_audio" && typeof value === "string")
				return;

			if (Array.isArray(value)) {
				apiformData.append(key, JSON.stringify(value));
			}

			else if (typeof value === "object" && value !== null) {
				if (key === "image") {
					// Only append if a new File is selected
					if (value.file && value.file instanceof File) {
						apiformData.append("image", value.file);
					} else {
						console.warn("No new image file selected. Backend requires a File.");
						// optionally: skip or prevent API call
					}
				} else if (value.file && value.file instanceof File) {
					apiformData.append(key, value.file);
				} else {
					Object.keys(value).forEach((nestedKey) => {
						const nestedValue = value[nestedKey];
						if (nestedValue) {
							apiformData.append(`${key}[${nestedKey}]`, nestedValue);
						}
					});
				}
			} else {
				apiformData.append(key, value);
			}
		});

		return apiformData;
	};
	const handleDeleteLoanImage = async () => {
		if (!openImg?.id) return;

		const result = await Swal.fire({
			title: "Are you sure?",
			text: "Do you really want to delete this image?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "Cancel",
		});

		if (result.isConfirmed) {
			try {
				const res = await axios.get(
					`${process.env.REACT_APP_API_URL}/delete-loan-image/${openImg.id}`,
					{ headers: { Authorization: `Bearer ${AuthToken}` } }
				);

				if (res.data.success) {
					setFormState((prevState) => ({
						...prevState,
						loan_images: prevState.loan_images.filter(
							(img) => img.id !== openImg.id
						),
					}));
					handleCloseImage();
					Swal.fire("Deleted!", "Loan image has been deleted.", "success");
				}
			} catch (error) {
				console.error(error);
				Swal.fire("Error!", "Image might already be deleted.", "error");
			}
		}
	};




	const handleUpdateLoanImage = async () => {
		if (!openImg?.file) {
			Swal.fire({
				icon: "error",
				title: "No Image Uploaded",
				text: "Please upload a new image before updating.",
			});
			return;
		}


		try {
			const formData = new FormData();
			formData.append("id", openImg.id);
			formData.append("image", openImg.file);



			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/update-loan-image`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${AuthToken}`,
						"Content-Type": "multipart/form-data",
					},
				}
			);

			if (res.data.success) {
				Swal.fire("Success!", "Draft updated successfully.", "success");
				handleCloseImage();
			} else {
				Swal.fire("Error!", "Please fill in the required fields.", "error");
			}
		} catch (error) {
			console.error(error);
			const errors = error.response?.data?.errors;
			if (errors) {
				const errorList = Object.values(errors)
					.flat()
					.map((err) => `<li>${err}</li>`)
					.join("");
				Swal.fire({
					title: "Please fix the following errors!",
					html: `<ul>${errorList}</ul>`,
					icon: "error",
					confirmButtonText: "Ok",
					customClass: { popup: "text-left" },
				});
			} else {
				Swal.fire("Error!", "Something went wrong. Please try again.", "error");
			}
		}
	};
	const handleCancelFamily = () => {
		Swal.fire({
			title: "Are you sure?",
			text: "Do you really want to cancel this family?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Yes, cancel it!",
			cancelButtonText: "No",
		}).then((result) => {
			if (result.isConfirmed) {

				axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

				axios.post(
					process.env.REACT_APP_API_URL + "/cancel-family/" + fsf_id
				)
					.then((res) => {
						if (res.data.success) {

							Swal.fire({
								title: "Cancelled!",
								text: "Family has been cancelled successfully.",
								icon: "success",
								timer: 1500,
								showConfirmButton: false,
							});

							navigate("/pending-attested");
						}
					})
					.catch((err) => {
						console.log(err);

						Swal.fire({
							title: "Error!",
							text: "Something went wrong.",
							icon: "error",
						});
					});
			}
		});
	};
	const handleComplete = () => {
		const apiformData = createFormData(formState);
		console.log(apiformData);
		axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
		axios
			.post(
				process.env.REACT_APP_API_URL + "/update-family/" + fsf_id,
				apiformData
			)
			.then((res) => {
				console.log(res, "res");
				if (res.data.success) {
					navigate("/darft-list");
					Swal.fire({
						title: "Success!",
						text: "Draft updated successfully.",
						icon: "success",
						confirmButtonText: "Ok",
					});
				} else {
					Swal.fire({
						title: "Error!",
						text: "Please fill in the required fields.",
						icon: "error",
						confirmButtonText: "Ok",
					});
				}
			})
			.catch((error) => {
				if (error.response && error.response.status === 422) {
					// Extract errors into an array
					const errors = error.response.data.errors;
					const errorList = Object.values(errors)
						.flat() // Flatten nested arrays
						.map((err) => `<li>${err}</li>`) // Convert each error into an HTML list item
						.join(""); // Join all list items

					// Display errors in a bulleted list
					Swal.fire({
						title: "Please fix the following errors!",
						html: `<ul>${errorList}</ul>`,
						icon: "error",
						confirmButtonText: "Ok",
						customClass: {
							popup: "text-left", // Align text to the left for better readability
						},
					});
				} else {
					// Generic error message
					Swal.fire({
						title: "Error!",
						text: "Something went wrong. Please try again.",
						icon: "error",
						confirmButtonText: "Ok",
					});
				}
			});

		// Handle form completion logic here
	};

	const formatDate = (dateString) => {
		if (!dateString) return "";
		return dateString.split("T")[0]; // keeps YYYY-MM-DD only
	};
	useEffect(() => {
		const fetchData = async () => {
			try {
				axios.defaults.headers.common[
					"Authorization"
				] = `Bearer ${AuthToken}`;
				const response = await axios.get(
					process.env.REACT_APP_API_URL + "/edit-family/" + fsf_id
				);
				setData(response.data.data);

				const people = response.data.people;
				console.log("Relocation image from backend:", people.relocation_img);
				console.log("CNIC image from backend:", people.cnic_f_img);



				const kinList = people.kins.map((kin, index) => ({
					id: kin.id, // Unique identifier for each kin
					relationship_id: kin.relationship_id || "", // Set default values if needed
					name: kin.name || "",
					cnic: kin.cnic || "",
					dob: kin.dob || "",
					slavry_year: kin.slavery_years || "",
				}));

				const child = people.childrens.map((child, index) => ({
					id: child.id,
					school_going: child.school_going || "",
					name: child.name || "",
					gender_id: child.gender_id || "",
					dob: child.dob || "",
					slavery_years: child.slavery_years || "",
					cnic: child.cnic || "",
					vocational_center: child.vocational_center || "",
				}));

				setFormState((prevState) => ({
					...prevState,
					peopleId: people?.id,
					name: people.stage?.name || "",
					enter_by: people.enter_by?.name || "",
					identifier_id: people.identifier_id,
					beneficiary_name: people.beneficiary_name,
					gender_id: people.gender_id,
					slavery_years: people.slavery_years,
					mob: people.mob,
					cnic: people.cnic,
					verification_date: people?.verification_date,
					rescue_date: people?.rescue_date,
					cnic_expire_date: people?.cnic_expire_date,
					assessment_date: formatDate(people?.assesment_date),
					church_name: people?.church_name,
					pastor_name: people?.pastor_name,
					pastor_cell_number: people?.pastor_cell_number,
					is_visited_by_pastor: people?.is_visited_by_pastor,
					frequent: people?.frequent,
					dob: people?.dob,
					live_on_brick_kiln:
						people?.brick_assessment?.live_on_brick_kiln?.toString() ??
						"",
					number_of_work_dependents:
						people?.brick_assessment?.number_of_work_dependents,
					number_of_dependents:
						people?.brick_assessment?.number_of_dependents,
					marital_status_id: people?.marital_status_id,
					marital_status_name: people?.marital_status?.name,

					slavery_reason_id: people?.slavery_reason_id,
					occupation_id: people?.occupation_id,
					reason: people?.brick_assessment?.reason,
					faith_id: people?.faith_id,
					baptised: people?.baptised,
					city_id: people?.city_id,
					verification_date: people?.verification_date,
					present_address: people?.present_address,
					permanent_address: people?.permanent_address,
					avatar: {
						file: null,
						preview: null,
						imgsrc: people.avatar,
					},
					cnic_f_img: {
						file: null,
						preview: null,
						imgsrc: people.cnic_f_img,
					},
					cnic_b_img: {
						file: null,
						preview: null,
						imgsrc: people.cnic_b_img,
					},
					union_council: people?.union_council,
					flagged: people?.flagged,
					worker_list: people?.worker_list || [],
					distance_to_home:
						people.brick_assessment?.distance_to_home || "",
					living_address:
						people?.brick_assessment?.living_address || "",
					family_story_audio: people?.family_story_audio || "",
					family_story_video: people?.testimony_video_link || "",
					///Family details
					is_parent_dependent: people?.is_parent_dependent,
					father_name: people?.family?.father_name,
					father_cnic: people?.family?.father_cnic,
					father_dob: people?.family?.father_dob,
					father_slavry_years: people?.family?.father_slavry_years,
					father_is_dead: people?.family?.father_is_dead,
					mother_name: people?.family?.mother_name,
					mother_cnic: people?.family?.mother_cnic,
					mother_dob: people?.family?.mother_dob,
					mother_slavry_years: people?.family?.mother_slavry_years,
					mother_is_dead: people?.family?.mother_is_dead,
					spouse_name: people?.family?.spouse_name,
					spouse_cnic: people?.family?.spouse_cnic,
					spouse_dob: people?.family?.spouse_dob,
					spouse_slavry_year: people?.family?.spouse_slavry_year,
					spouse_is_dead: people?.family?.spouse_is_dead,
					relationship_id: null,
					kin_list: kinList,
					///Family story
					family_story: people?.family_story,
					extra_comments: people?.extra_comments,
					prayer_request: people?.prayer_request?.prayer,
					///Childrens
					no_child: people?.no_child,
					child: child,
					///Loan
					loanId: people?.laon?.id || "",
					brick_kiln_id: people?.brick_kiln_id,
					loan_type_id: people?.loan?.loan_type_id,
					est_loan_amount: people?.loan?.est_loan_amount,
					loan_amount: people?.loan?.loan_amount || 0,
					medical_amount: people?.loan?.medical_amount || 0,
					food_ration: people?.loan?.food_ration,
					meal_amount: people?.loan?.meal_amount,
					khatta_amount: people?.loan?.khatta_amount,
					live_by_choice: people?.brick_assessment?.live_by_choice,
					utility_amount: people?.loan?.utility_amount,
					rent_amount: people?.loan?.rent_amount,
					other: people?.loan?.other,
					affidavit_amount: people?.loan?.affidavit_amount,
					total_pkr: people?.loan?.total_pkr,
					transportation: people?.loan?.transportation || 0,
					loan_images: people?.loan?.loan_images || [],
					unpaid_loan_invoice: {
						file: null,
						preview: null,
						imgsrc: people.loan?.unpaid_loan_invoice,
					},
					khatta_unpaid_file: {
						file: null,
						preview: null,
						imgsrc: people?.loan?.khatta_unpaid_file,
					},

					//Acknowledgement
					identifier: people?.identifier,
					mobilizer: people?.mobilizer,
					mobilizer_id: people?.mobilizer_id,
					data_tested: people?.data_tested,
					//fsf number
					f_number: people?.f_number,
					is_allow_to_meet_relatives:
						people?.brick_assessment?.is_allow_to_meet_relatives,
					working_hours: people?.brick_assessment?.working_hours,
					working_years_on_brick_kiln:
						people.brick_assessment?.working_years_on_brick_kiln,
					first_loan_amount:
						people.brick_assessment?.first_loan_amount,
					loan_year: people.brick_assessment?.loan_year,
					// Feasubility Analysis
					want_to_leave_work:
						people?.brick_assessment?.want_to_leave_work,

					why: people.brick_assessment?.why,
					plans_after_leaving_work:
						people.brick_assessment?.plans_after_leaving_work,
					willing_to_learn_new_skills:
						people.brick_assessment?.willing_to_learn_new_skills,
					new_skill_or_job: people.brick_assessment?.new_skill_or_job,
					willing_to_educate_children:
						people.brick_assessment?.willing_to_educate_children,
					willing_to_pay_in_installments:
						people.brick_assessment?.willing_to_pay_in_installments,

					//family gallery

					affidavit: {
						file: null,
						preview: null,
						imgsrc: people?.affidavit || "",
					},
					relocation_img: {
						file: null,
						preview: null,
						imgsrc: people?.relocation_img ? people.relocation_img : "",
					},

					release_img: {
						file: null,
						preview: null,
						imgsrc: people?.release_img || "",
					},
					family_check_img: {
						file: null,
						preview: null,
						imgsrc: people?.family_check_img || "",
					},
					family_working_img: {
						file: null,
						preview: null,
						imgsrc: people?.family_working_img || "",
					},
					new_home_img: {
						file: null,
						preview: null,
						imgsrc: people?.new_home_img || "",
					},

					img_1: {
						file: null,
						preview: null,
						imgsrc: people?.img_1 || "",
					},
					img_2: {
						file: null,
						preview: null,
						imgsrc: people?.img_2 || "",
					},
					img_3: {
						file: null,
						preview: null,
						imgsrc: people?.img_3 || "",
					},
					img_4: {
						file: null,
						preview: null,
						imgsrc: people?.img_4 || "",
					},
					img_5: {
						file: null,
						preview: null,
						imgsrc: people?.img_5 || "",
					},
					img_6: {
						file: null,
						preview: null,
						imgsrc: people?.img_6 || "",
					},

					//family Business



					// business_donor: people?.business?.business_donor || "",
					// business_type_id: people?.business?.business_type_id || "",
				}));

				handleSearch(people.city?.name);
				console.log(data);

				console.log(response, "called");
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		fetchData();
	}, [fsf_id]);

	const handleIdentifier = (e) => {
		const selectedId = parseInt(e.target.value, 10);
		const selectedIdentifier = data.identifiers.find(
			(iden) => iden.id === selectedId
		);

		setFormState((prevState) => ({
			...prevState,
			identifier_id: selectedId,
			identifier: selectedIdentifier || null,
		}));

		console.log(selectedIdentifier, "iden");
	};
	console.log(
		"Family working image preview:",
		formState.family_working_img.preview,
		"Image src:",
		formState.family_working_img.imgsrc,
		"Final URL:",

		(process.env.REACT_APP_IMG_URL + formState.family_working_img.imgsrc)
	);


	const handleStatus = (e) => {
		const selectedId = parseInt(e.target.value, 10);
		setFormState((prevState) => ({
			...prevState,
			data_tested: selectedId,
		}));
	};
	const handleMobilizer = (e) => {
		const selectedId = parseInt(e.target.value, 10);
		const selectedIdentifier = data.identifiers.find(
			(iden) => iden.id === selectedId
		);

		setFormState((prevState) => ({
			...prevState,
			mobilizer_id: selectedId,
			mobilizer: selectedIdentifier || null,
		}));

		console.log(selectedIdentifier, "iden");
	};

	const handleChange = (e) => {
		const { name, value, type, files } = e.target;
		console.log(name, "name");

		if (type === "file") {
			const file = files[0];
			if (!file) return;

			const previewUrl = URL.createObjectURL(file);

			setOpenImg((prev) => ({
				...prev,
				file,
				preview: previewUrl,
			}));


			setFormState((prevState) => ({
				...prevState,
				loan_images: prevState.loan_images.map((img) =>
					img.id === openImg.id ? { ...img, file, preview: previewUrl } : img
				),
			}));

			return;
		}


		if (value === "add_new") {
			handleModalShow();
			return;
		}


		setFormState((prevState) => ({
			...prevState,
			[name]: value,
		}));

		// Handle CNIC field
		if (name === "cnic") {
			const formattedCnic = formatCnic(value);
			if (value.length >= 14) checkCnic(formattedCnic);

			setFormState((prevState) => ({
				...prevState,
				cnic: formattedCnic,
			}));

			setError((prevError) => ({
				...prevError,
				cnic: validateCnic(formattedCnic) ? "" : "",
			}));
		}

		// Handle city search
		if (name === "city_id") handleSearch(value);
	};


	const addKin = () => {
		setFormState({
			...formState,
			kin_list: [
				...formState.kin_list,
				{
					kid: formState.kin_list.length + 1,
					relationship_id: "",
					name: "",
					cnic: "",
					dob: "",
					slavry_year: "",
				},
			],
		});
	};

	const removeKin = (index) => {
		const updatedkin_list = formState.kin_list.filter(
			(_, i) => i !== index
		);
		setFormState({
			...formState,
			kin_list: updatedkin_list,
		});
	};

	const handleKinChange = (index, e) => {
		const { name, value } = e.target;

		// Create a copy of the kin_list
		const updatedkin_list = [...formState.kin_list];

		let formattedValue = value;

		// Check if the field is 'cnic' and apply validation
		if (name === "cnic") {
			// Format and ensure CNIC is 15 characters long
			formattedValue = formatCnic(value);
			if (formattedValue.length > 15) {
				formattedValue = formattedValue.slice(0, 15); // Truncate to 15 characters
			}
		}

		// Update the specific kin's field
		updatedkin_list[index] = {
			...updatedkin_list[index],
			[name]: formattedValue,
		};

		// Update the state
		setFormState({
			...formState,
			kin_list: updatedkin_list,
		});
	};

	const handleChangeStory = ({ name, value }) => {
		setFormState((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};
	const addKid = () => {
		setFormState({
			...formState,
			child: [
				...formState.child,
				{
					cid: formState.child.length + 1,
					school_going: "",
					name: "",
					gender_id: "",
					dob: "",
					slavery_years: "",
					cnic: "",
					vocational_center: "",
				},
			],
		});
	};

	const removeKid = (index) => {
		const child = formState.child[index];

		Swal.fire({
			title: "Are you sure?",
			text: "This child record will be permanently deleted!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#d33",
			cancelButtonColor: "#3085d6",
			confirmButtonText: "Yes, delete it",
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					// 🔹 API CALL
					await axios.delete(`${process.env.REACT_APP_API_URL}/children/${child.id}`);

					// 🔹 Update UI after success
					const updatedchilds = formState.child.filter(
						(_, i) => i !== index
					);

					setFormState({
						...formState,
						child: updatedchilds,
					});

					Swal.fire(
						"Deleted!",
						"Child record has been deleted.",
						"success"
					);
				} catch (error) {
					Swal.fire(
						"Error!",
						"Failed to delete record. Try again.",
						"error"
					);
				}
			}
		});
	};

	const handleKidChange = (index, e) => {
		const { name, value } = e.target;

		// Copy the existing child array
		const updatedchilds = [...formState.child];

		let formattedValue = value;

		// Apply formatting and validation for CNIC
		if (name === "cnic") {
			formattedValue = formatCnic(value);
			if (formattedValue.length > 15) {
				formattedValue = formattedValue.slice(0, 15); // Truncate to 15 characters
			}
		}

		// Update the specific child's field
		updatedchilds[index] = {
			...updatedchilds[index],
			[name]: formattedValue,
		};

		// Update the state
		setFormState({
			...formState,
			child: updatedchilds,
		});
	};

	const handleChangeLoan = (e) => {
		const { name, value } = e.target;

		setFormState((prevState) => {
			const updatedState = {
				...prevState,
				[name]: value,
			};
			console.log(name, value);

			// Recalculate total_pkr
			const total = [
				"loan_amount",
				"medical_amount",
				"food_ration",
				"meal_amount",
				"utility_amount",
				"rent_amount",
				"other",
				"affidavit_amount",
				"transportation",
			].reduce(
				(acc, key) => acc + (parseFloat(updatedState[key]) || 0),
				0
			);

			return { ...updatedState, total_pkr: total };
		});
	};

	const updateCnicField = (field, value) => {
		const formattedCnic = formatCnic(value); // Format CNIC input
		setFormState((prevState) => ({
			...prevState,
			[field]: formattedCnic, // Update formatted CNIC in the form state
		}));
	};
	const audioUrl = formState.family_story_audio
		? `${process.env.REACT_APP_IMG_URL}${formState.family_story_audio}`
		: null;
	const uploadImages = async (e, model, modelId, fileKey) => {
		const file = e.target.files[0];

		if (!file) {
			Swal.fire({
				icon: "error",
				title: "No Image Selected",
				text: "Please select an image before uploading.",
			});
			return;
		}


		const previewUrl = URL.createObjectURL(file);
		setFormState((prev) => ({
			...prev,
			[fileKey]: {
				...prev[fileKey],
				file,
				preview: previewUrl,
			},
		}));


		try {
			const formData = new FormData();
			formData.append("model", model);
			formData.append("id", modelId);
			formData.append("file_key", fileKey);
			formData.append("file", file);



			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload-images`,
				formData,
				{
					headers: {
						Authorization: `Bearer ${AuthToken}`,
						"Content-Type": "multipart/form-data",
					},
				}
			);

			if (res.data.success) {
				Swal.fire("Success!", "Image uploaded successfully.", "success");
			} else {
				Swal.fire("Error!", "Upload failed. Please try again.", "error");
			}
		} catch (error) {
			console.error(error);
			const errors = error.response?.data?.errors;
			if (errors) {
				const errorList = Object.values(errors)
					.flat()
					.map((err) => `<li>${err}</li>`)
					.join("");
				Swal.fire({
					title: "Please fix the following errors!",
					html: `<ul>${errorList}</ul>`,
					icon: "error",
					confirmButtonText: "Ok",
					customClass: { popup: "text-left" },
				});
			} else {
				Swal.fire(
					"Error!",
					"Something went wrong. Please try again.",
					"error"
				);
			}
		}
	};



	return (
		<PageLayout>
			<Row>
				<Col xl={12}>
					<div className="mc-card">
						<div className="mc-breadcrumb">
							<h3 className="mc-breadcrumb-title">
								{/* <i className="material-icons">
									family_restroom
								</i> */}
								Edit Family Record {formState.f_number}
							</h3>



							<ul className="mc-breadcrumb-list">
								<li className="mc-breadcrumb-item">
									<Link
										to="/"
										className="mc-breadcrumb-link"
										style={{ color: "#077834" }}
									>
										Home
									</Link>
								</li>
								<li className="mc-breadcrumb-item">
									Edit Family Record
								</li>
							</ul>
						</div>
					</div>
				</Col>
			</Row>

			<Row>
				<Col xl={12}>
					<div className="mc-card">
						<div class="col-xl-12"><h5 class="mc-divide-title mb-4"><small>Data Entered By:{formState.enter_by}</small> </h5></div>

						<FormWizard
							shape="circle"
							color="#077834"
							onComplete={handleComplete}
							onTabChange={tabChanged}
						>
							{/* ------------------- BENEFICIARY details ------------------------------ */}
							<FormWizard.TabContent
								title="Beneficiary Details"
								icon="ti-user"
							>
								<>
									<Row className="mb-3">
										<Row style={{ position: "relative" }}>
											<Col md={4}>
												<div
													className="mc-card"
													style={{
														position: "relative",
													}}
												>
													{/* Avatar */}
													<Form.Group>
														<Form.Label
															style={{
																width: "100%",
																textAlign:
																	"center",
																display: "flex",
																flexDirection:
																	"column",
																alignItems:
																	"center",
																justifyContent:
																	"center",
																border: "none",
															}}
														>
															{!formState.avatar
																.preview &&
																!formState.avatar
																	.imgsrc ? (
																<>
																	{
																		"Add Beneficiary Pic"
																	}
																	<i
																		style={{
																			color: "#1976D2",
																			cursor: "pointer",
																			fontSize:
																				"4rem",
																		}}
																		className="material-icons"
																	>
																		<FaUser />
																	</i>
																</>
															) : (
																<img
																	src={
																		formState
																			.avatar
																			.preview ||
																		process
																			.env
																			.REACT_APP_IMG_URL +
																		formState
																			.avatar
																			.imgsrc
																	}
																	alt="Beneficiary Pic"
																	style={{
																		width: "100%",
																		height: "auto",
																		borderRadius:
																			"10px",
																		objectFit:
																			"cover",
																		boxShadow:
																			"0px 4px 8px rgba(0, 0, 0, 0.2)",
																		border: "2px solid #077834",
																		padding:
																			"5px",
																	}}
																/>
															)}
															<Form.Control
																type="file"
																hidden
																name="avatar"
																placeholder="Add Beneficiary Pic"
																onChange={(e) =>
																	handleFileChange(
																		e,
																		"avatar",
																		500,
																		500
																	)
																}
															/>
														</Form.Label>
														{formState.avatar
															?.file ||
															formState.avatar
																?.imgsrc ? (
															""
														) : (
															<span className="c_error">
																Please add
																Profile Picture
															</span>
														)}
													</Form.Group>
												</div>
											</Col>

											<Col md={8}>
												<Row>
													{/* need to enter dates here */}
													<Form.Group
														as={Col}
														md="6"
														controlId="validationCustom01"
													>
														<FloatingLabel
															controlId="floatingTextarea"
															label="Select Partner"
															className="mb-3"
														>
															<Form.Select
																onChange={(e) =>
																	handleIdentifier(
																		e
																	)
																}
																name="identifier_id"
																value={
																	formState.identifier_id ||
																	""
																}
																required
															>
																<option
																	value={""}
																>
																	Select...
																</option>
																{data?.identifiers?.map(
																	(
																		identifier
																	) => (
																		<option
																			key={
																				identifier.id
																			}
																			value={
																				identifier.id
																			}
																		>
																			{
																				identifier.name
																			}{" "}
																			(
																			{
																				identifier.org
																			}
																			)
																		</option>
																	)
																)}
															</Form.Select>
															{formState.identifier_id ? (
																""
															) : (
																<span className="c_error">
																	Please
																	Select
																	Identifier
																</span>
															)}
														</FloatingLabel>
													</Form.Group>

													<Form.Group
														as={Col}
														md="6"
														controlId="validationCustom01"
													>
														<FloatingLabel
															controlId="floatingTextarea"
															label="Assessment Date"
															className="mb-3"
														>
															<Form.Control
																type="date"
																name="assessment_date"
																value={
																	formState.assessment_date ||
																	""
																}
																onChange={
																	handleChange
																}
															/>
															{!formState.assessment_date && (
																<span className="c_error">
																	Please enter
																	assessment
																	date
																</span>
															)}
														</FloatingLabel>
													</Form.Group>

													<Form.Group
														as={Col}
														md="6"
														controlId="validationCustom01"
													>
														<FloatingLabel
															controlId="floatingTextarea"
															label="Verification Date"
															className="mb-3"
														>
															<Form.Control
																type="date"
																onChange={
																	handleChange
																}
																name="verification_date"
																placeholder=""
																value={
																	formState.verification_date ||
																	""
																}
															/>
															{formState.verification_date ? (
																""
															) : (
																<span className="c_error">
																	Please enter
																	Verification
																	Date
																</span>
															)}
														</FloatingLabel>
													</Form.Group>

													<Form.Group
														as={Col}
														md="6"
														controlId="validationCustom01"
													>
														<FloatingLabel
															controlId="floatingTextarea"
															label="Rescue Date"
															className="mb-3"
														>
															<Form.Control
																type="date"
																onChange={
																	handleChange
																}
																name="rescue_date"
																placeholder=""
																value={
																	formState.rescue_date ||
																	""
																}
															/>
															{formState.rescue_date ? (
																""
															) : (
																<span className="c_error">
																	Please enter
																	Rescue Date
																</span>
															)}
														</FloatingLabel>
													</Form.Group>

													{/* Pictures  */}
													<Col md={6}>
														<div
															className="mc-card"
															style={{
																position:
																	"relative",
															}}
														>
															<Form.Group>
																<Form.Label
																	style={{
																		width: "100%",
																		textAlign:
																			"center",
																		display:
																			"flex",
																		flexDirection:
																			"column",
																		alignItems:
																			"center",
																		justifyContent:
																			"center",
																	}}
																>
																	{!formState
																		.cnic_f_img
																		.preview &&
																		!formState
																			.cnic_f_img
																			.imgsrc ? (
																		<>
																			{
																				"Add Beneficiary CNIC Front"
																			}
																			<i
																				style={{
																					color: "#1976D2",
																					cursor: "pointer",
																					fontSize:
																						"4rem",
																				}}
																				className="material-icons"
																			>
																				<FaIdCard />
																			</i>
																		</>
																	) : (
																		<img
																			src={
																				formState
																					.cnic_f_img
																					.preview ||
																				process
																					.env
																					.REACT_APP_IMG_URL +
																				formState
																					.cnic_f_img
																					.imgsrc
																			}
																			alt="Beneficiary CNIC Front"
																			style={{
																				width: "100%",
																				height: "120px",
																				borderRadius:
																					"10px",
																				objectFit:
																					"cover",
																				boxShadow:
																					"0px 4px 8px rgba(0, 0, 0, 0.2)",
																				border: "2px solid #077834",
																				padding:
																					"5px",
																			}}
																		/>
																	)}
																	<Form.Control
																		type="file"
																		hidden
																		name="cnic_f_img"
																		placeholder="Add Beneficiary CNIC Front"
																		onChange={(
																			e
																		) =>
																			handleFileChange(
																				e,
																				"cnic_f_img",
																				500,
																				250
																			)
																		}
																	/>
																</Form.Label>
																{formState
																	.cnic_f_img
																	.file ||
																	formState
																		.cnic_f_img
																		.imgsrc ? (
																	""
																) : (
																	<span className="c_error">
																		Please
																		Add
																		Beneficiary
																		CNIC
																		Front
																	</span>
																)}
															</Form.Group>
														</div>
													</Col>

													<Col md={6}>
														<div
															className="mc-card"
															style={{
																position:
																	"relative",
															}}
														>
															<Form.Group>
																<Form.Label
																	style={{
																		width: "100%",
																		height: "auto",
																		borderRadius:
																			"10px",
																		objectFit:
																			"cover",

																		padding:
																			"5px",
																	}}
																>
																	{!formState
																		.cnic_b_img
																		.preview &&
																		!formState
																			.cnic_b_img
																			.imgsrc ? (
																		<>
																			{
																				"Add Beneficiary CNIC Back"
																			}
																			<i
																				style={{
																					color: "#1976D2",
																					cursor: "pointer",
																					fontSize:
																						"4rem",
																				}}
																				className="material-icons"
																			>
																				<FaIdCardAlt />
																			</i>
																		</>
																	) : (
																		<img
																			src={
																				formState
																					.cnic_b_img
																					.preview ||
																				process
																					.env
																					.REACT_APP_IMG_URL +
																				formState
																					.cnic_b_img
																					.imgsrc
																			}
																			alt="Beneficiary CNIC Back"
																			style={{
																				width: "100%",
																				height: "110px",
																				borderRadius:
																					"10px",
																				objectFit:
																					"cover",
																				boxShadow:
																					"0px 4px 8px rgba(0, 0, 0, 0.2)",
																				border: "2px solid #077834",
																				padding:
																					"5px",
																			}}
																		/>
																	)}
																	<Form.Control
																		type="file"
																		hidden
																		name="cnic_b_img"
																		placeholder="Add Beneficiary CNIC Back"
																		onChange={(
																			e
																		) =>
																			handleFileChange(
																				e,
																				"cnic_b_img",
																				500,
																				250
																			)
																		}
																	/>
																</Form.Label>
																{formState
																	.cnic_b_img
																	.file ||
																	formState
																		.cnic_b_img
																		.imgsrc ? (
																	""
																) : (
																	<span className="c_error ">
																		Please
																		Add
																		Beneficiary
																		CNIC
																		Back
																	</span>
																)}
															</Form.Group>
														</div>
													</Col>
												</Row>
											</Col>
										</Row>


										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Status"
												className="mb-3"

											>
												<Form.Control
													required
													readOnly
													type="text"
													onChange={handleChange}
													name="name"
													placeholder=""
													value={
														formState.name ||
														""
													}
												/>
												{formState.name ? (
													""
												) : (
													<span className="c_error">
														Please Enter status

													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Beneficiary Name"
												className="mb-3"
											>
												<Form.Control
													required
													type="text"
													onChange={handleChange}
													name="beneficiary_name"
													placeholder=""
													value={
														formState.beneficiary_name ||
														""
													}
												/>
												{formState.beneficiary_name ? (
													""
												) : (
													<span className="c_error">
														Please Enter Beneficiary
														Name
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											className="mb-3"
										>
											<FloatingLabel label="Enter CNIC">
												<Form.Control
													type="text"
													placeholder="Enter CNIC"
													name="cnic"
													value={formState.cnic || ""}
													onChange={handleChange}
													maxLength={15} // Prevent user from typing more than 15 characters
													minLength={15}
												/>
												{formState.cnic ? (
													""
												) : (
													<span className="c_error">
														Please Enter CNIC
													</span>
												)}
											</FloatingLabel>
											{error?.cnic && (
												<span className="c_error">
													{`${String(
														error?.cnic || ""
													).toUpperCase()}*`}
												</span>
											)}
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											className="mb-3"
										>
											<FloatingLabel label="CNIC expiry date">
												<Form.Control
													type="date"
													placeholder="CNIC expiry data"
													name="cnic_expire_date"
													value={
														formState.cnic_expire_date ||
														""
													}
													onChange={handleChange}
												/>
												{formState.cnic_expire_date ? (
													""
												) : (
													<span className="c_error">
														Please Enter CNIC expire
														date
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Cell Number"
												className="mb-3"
											>
												<Form.Control
													type="text"
													onChange={handleChange}
													name="mob"
													placeholder=""
													value={formState.mob || ""}
												/>
												{formState.mob ? (
													""
												) : (
													<span className="c_error">
														Please Enter Cell Number
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Select Gender"
												className="mb-3"
											>
												<Form.Select
													type="text"
													onChange={handleChange}
													name="gender_id"
													placeholder=""
													value={
														formState.gender_id ||
														""
													}
												>
													<option value={""}>
														Select...
													</option>
													{data?.gender?.map(
														(gender) => (
															<option
																key={gender.id}
																value={
																	gender.id
																}
															>
																{gender.name}
															</option>
														)
													)}
												</Form.Select>
												{formState.gender_id ? (
													""
												) : (
													<span className="c_error">
														Please Select Gender
													</span>
												)}
											</FloatingLabel>
										</Form.Group>
										<Form.Group
											as={Col}
											md="4"
											className="mb-3"
										>
											<FloatingLabel label="Date of Birth">
												<Form.Control
													type="date"
													placeholder="Date of Birth"
													name="dob"
													value={formState.dob || ""}
													onChange={handleChange}
												/>
												{formState.dob ? (
													""
												) : (
													<span className="c_error">
														Please Select Date of
														Birth
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom02"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Marital Status"
												className="mb-3"
											>
												<Form.Select
													type="number"
													name="marital_status_id"
													value={
														formState.marital_status_id ||
														""
													}
													onChange={handleChange}
												>
													<option value="">
														Select...
													</option>
													{data?.maritalStatuses?.map(
														(martital) => {
															return (
																<option
																	key={
																		martital.id
																	}
																	value={
																		martital.id
																	}
																>
																	{
																		martital.name
																	}
																</option>
															);
														}
													)}
												</Form.Select>
												{formState.marital_status_id ? (
													""
												) : (
													<span className="c_error">
														Please Select Marital
														Status
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Occupation"
												className="mb-3"
											>
												<Form.Select
													name="occupation_id"
													value={
														formState.occupation_id ||
														""
													}
													onChange={handleChange}
												>
													<option value="">
														Select Occupation
													</option>
													{data?.occupations?.map(
														(occupation) => (
															<option
																key={
																	occupation.id
																}
																value={
																	occupation.id
																}
															>
																{
																	occupation.name
																}
															</option>
														)
													)}
												</Form.Select>
												{formState.occupation_id ? (
													""
												) : (
													<span className="c_error">
														Please Select Occupation
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Slavery Reason"
												className="mb-3"
											>
												<Form.Select
													name="slavery_reason_id"
													value={
														formState.slavery_reason_id ||
														""
													}
													onChange={handleChange}
												>
													<option value="">
														Slavery Reason
													</option>
													{data?.slaveryReasons?.map(
														(slaveryReason) => (
															<option
																key={
																	slaveryReason.id
																}
																value={
																	slaveryReason.id ||
																	""
																}
															>
																{
																	slaveryReason.name
																}
															</option>
														)
													)}
												</Form.Select>
												{formState.slavery_reason_id ? (
													""
												) : (
													<span className="c_error">
														Please Select Slavery
														Reason
													</span>
												)}
											</FloatingLabel>
										</Form.Group>
										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Slavery Years"
												className="mb-3"
											>
												<Form.Control
													type="number"
													onChange={handleChange}
													name="slavery_years"
													placeholder=""
													value={
														formState.slavery_years ||
														""
													}
												/>
												{formState.slavery_years ? (
													""
												) : (
													<span className="c_error">
														Required
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="4"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Religion"
												className="mb-3"
											>
												<Form.Select
													name="faith_id"
													value={
														formState.faith_id || ""
													}
													onChange={handleChange}
												>
													<option value="">
														Select Religion
													</option>
													{data?.religions?.map(
														(religion) => (
															<option
																key={
																	religion.id
																}
																value={
																	religion.id ||
																	""
																}
															>
																{religion.name}
															</option>
														)
													)}
												</Form.Select>
												{formState.faith_id ? (
													""
												) : (
													<span className="c_error">
														Required
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										{formState.faith_id == 2 ? (
											<>
												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Baptized"
														className="mb-3"
													>
														<Form.Select
															name="baptised"
															value={
																formState.baptised
															}
															onChange={
																handleChange
															}
														>
															<option
																value=""
																disabled
															>
																Choose
															</option>
															<option value="1">
																Yes
															</option>
															<option value="0">
																No
															</option>
														</Form.Select>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Flagged"
														className="mb-3"
													>
														<Form.Select
															name="flagged"
															value={
																formState.flagged
															}
															onChange={
																handleChange
															}
														>
															<option
																value=""
																disabled
															>
																Choose
															</option>
															<option value="1">
																Yes
															</option>
															<option value="0">
																No
															</option>
														</Form.Select>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Member of a Church"
														className="mb-3"
													>
														<Form.Select
															name="is_member_of_church"
															value={
																formState.is_member_of_church
															}
															onChange={
																handleChange
															}
														>
															<option
																value=""
																disabled
															>
																Choose
															</option>
															<option value="1">
																Yes
															</option>
															<option value="0">
																No
															</option>
														</Form.Select>
													</FloatingLabel>
												</Form.Group>

												{formState.is_member_of_church ==
													1 ? (
													<>
														<DivideTitleComponent
															title="Church Details"
															className="mb-4 mt-3"
														/>
														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Church Name"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={
																		handleChange
																	}
																	name="church_name"
																	placeholder=""
																	value={
																		formState.church_name
																	}
																/>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Pastor Name"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={
																		handleChange
																	}
																	name="pastor_name"
																	placeholder=""
																	value={
																		formState.pastor_name
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Pastor Cell Number"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={
																		handleChange
																	}
																	name="pastor_cell_number"
																	placeholder=""
																	value={
																		formState.pastor_cell_number
																	}
																/>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Visited By Pastor"
																className="mb-3"
															>
																<Form.Select
																	name="is_visited_by_pastor"
																	value={
																		formState.is_visited_by_pastor
																	}
																	onChange={
																		handleChange
																	}
																>
																	<option
																		value=""
																		disabled
																	>
																		Choose
																	</option>
																	<option value="1">
																		Yes
																	</option>
																	<option value="0">
																		No
																	</option>
																</Form.Select>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="How frequent?"
																className="mb-3"
															>
																<Form.Select
																	name="frequent"
																	value={
																		formState.frequent
																	}
																	onChange={
																		handleChange
																	}
																>
																	<option
																		value=""
																		disabled
																	>
																		Choose
																	</option>
																	<option value="Weekly">
																		Weekly
																	</option>
																	<option value="Monthly">
																		Monthly
																	</option>
																</Form.Select>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="When was your last church visit?"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={
																		handleChange
																	}
																	name="last_time_church"
																	placeholder=""
																	value={
																		formState.last_time_church
																	}
																/>
															</FloatingLabel>
														</Form.Group>
													</>
												) : (
													""
												)}
											</>
										) : (
											""
										)}
									</Row>

									<DivideTitleComponent
										title="Address Details"
										className="mb-4 mt-3"
									/>

									<Row>
										<Form.Group
											as={Col}
											md="6"
											className="mb-3"
										>
											<FloatingLabel label="Union Council">
												<Form.Control
													type="text"
													placeholder=""
													name="union_council"
													value={
														formState.union_council ||
														""
													}
													onChange={handleChange}
												/>
												{formState.union_council ? (
													""
												) : (
													<span className="c_error">
														Please Enter Union
														Council
													</span>
												)}
											</FloatingLabel>
										</Form.Group>
										<Form.Group
											as={Col}
											md="6"
											className="mb-3"
											style={{ position: "relative" }}
										>
											<FloatingLabel label="City">
												<Form.Control
													type="text"
													placeholder="Enter City"
													value={searchValue || ""} // Use the search value to display what the user types
													onChange={(e) => {
														handleSearch(
															e.target.value
														); // Update search
														setFormState(
															(prevState) => ({
																...prevState,
																city_id: "", // Clear city_id while typing
															})
														);
													}}
													onFocus={() =>
														setIsFocused(true)
													}
													onBlur={() =>
														setTimeout(
															() =>
																setIsFocused(
																	false
																),
															150
														)
													} // Delay hiding dropdown
													name="city_id"
												/>
												{!formState.city_id && (
													<span className="c_error">
														Please Enter City
													</span>
												)}
											</FloatingLabel>

											{isFocused && (
												<ul
													style={{
														position: "absolute",
														top: "100%",
														left: "0",
														right: "0",
														background: "#fff",
														border: "1px solid #ddd",
														zIndex: 1000,
														maxHeight: "150px",
														overflowY: "auto",
														listStyleType: "none",
														padding: "0",
														margin: "0",
													}}
												>
													{filteredCities?.length >
														0 ? (
														filteredCities.map(
															(city) => (
																<li
																	key={
																		city.id
																	}
																	onClick={() => {
																		setSearchValue(
																			city.name
																		); // Set the city name as input value
																		setFormState(
																			(
																				prevState
																			) => ({
																				...prevState,
																				city_id:
																					city.id, // Store city ID in the state
																			})
																		);
																		setIsFocused(
																			false
																		); // Close dropdown after selection
																	}}
																	style={{
																		padding:
																			"10px",
																		cursor: "pointer",
																		borderBottom:
																			"1px solid #eee",
																	}}
																>
																	{city.name}
																</li>
															)
														)
													) : (
														<li
															style={{
																padding: "10px",
																cursor: "default",
																textAlign:
																	"center",
																color: "#888",
															}}
														>
															No city with this
															name
														</li>
													)}
												</ul>
											)}
										</Form.Group>
										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Present Address"
												className="mb-3"
											>
												<Form.Control
													type="textarea"
													placeholder="Enter Present Address"
													onChange={handleChange}
													name="present_address"
													value={
														formState.present_address ||
														""
													}
												/>
												{formState.present_address ? (
													""
												) : (
													<span className="c_error">
														Please Enter Present
														Address
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Permanent Address"
												className="mb-3"
											>
												<Form.Control
													type="textarea"
													placeholder="Enter Permanent Address"
													onChange={handleChange}
													name="permanent_address"
													value={
														formState.permanent_address ||
														""
													}
												/>
												{formState.permanent_address ? (
													""
												) : (
													<span className="c_error">
														Please Enter Present
														Address
													</span>
												)}
											</FloatingLabel>
										</Form.Group>
									</Row>
								</>
								{/* <Persondetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Person Details", childData)
                  }
                /> */}
							</FormWizard.TabContent>

							{/* ------------------- BENEFICIARY FAMILY ------------------------------ */}

							<FormWizard.TabContent
								title="Beneficiary Family"
								icon="ti-home"
								isValid={validateTab1()}
								validationError={errorMessages}
							>
								<>
									<Row className="mb-3">
										<Col md={7}>
											{" "}
											<DivideTitleComponent
												title="Parents Information"
												className="mb-4 mt-3"
											/>
										</Col>
										<Col md={5}>
											<Form.Check
												type={"checkbox"}
												id={`default-1`}
												name="is_parent_dependent"
												checked={
													formState.is_parent_dependent
												} // Bind to state
												onChange={(e) =>
													setFormState({
														...formState,
														is_parent_dependent:
															e.target.checked,
													})
												} // Inline change handler
												label={
													"Parents are Dependent on Beneficiary ? "
												}
											/>
										</Col>
									</Row>
									{formState.is_parent_dependent ? (
										<>
											<Row>
												<Col md={12}>
													<DivideTitleComponent
														title="Father Information"
														className="mb-4 mt-3"
													/>
												</Col>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Father Name"
														className="mb-3"
													>
														<Form.Control
															type="text"
															onChange={
																handleChange
															}
															name="father_name"
															placeholder=""
															value={
																formState.father_name ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Father CNIC"
														className="mb-3"
													>
														<Form.Control
															type="text"
															maxLength={15}
															onChange={(event) =>
																updateCnicField(
																	"father_cnic",
																	event.target
																		.value
																)
															}
															name="father_cnic"
															placeholder=""
															value={
																formState.father_cnic ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Father D-O-B"
														className="mb-3"
													>
														<Form.Control
															type="date"
															onChange={
																handleChange
															}
															name="father_dob"
															placeholder=""
															value={
																formState.father_dob ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Slavery Years *"
														className="mb-3"
													>
														<Form.Control
															type="number"
															onChange={
																handleChange
															}
															name="father_slavry_years"
															placeholder=""
															value={
																formState.father_slavry_years ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Is Dead ?"
														className="mb-3"
													>
														<Form.Select
															onChange={
																handleChange
															}
															name="father_is_dead"
															placeholder=""
															value={
																formState.father_is_dead ||
																""
															}
														>
															<option value={0}>
																No
															</option>
															<option value={1}>
																Yes
															</option>
														</Form.Select>
													</FloatingLabel>
												</Form.Group>
											</Row>

											<Row>
												<Col md={12}>
													<DivideTitleComponent
														title="Mother Information"
														className="mb-4 mt-3"
													/>
												</Col>
												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Mother Name"
														className="mb-3"
													>
														<Form.Control
															type="text"
															onChange={
																handleChange
															}
															name="mother_name"
															placeholder=""
															value={
																formState.mother_name ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Mother CNIC"
														className="mb-3"
													>
														<Form.Control
															type="text"
															maxLength={15}
															onChange={(event) =>
																updateCnicField(
																	"mother_cnic",
																	event.target
																		.value
																)
															}
															name="mother_cnic"
															placeholder=""
															value={
																formState.mother_cnic ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Mother D-O-B"
														className="mb-3"
													>
														<Form.Control
															type="date"
															onChange={
																handleChange
															}
															name="mother_dob"
															placeholder=""
															value={
																formState.mother_dob ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Slavery Years *"
														className="mb-3"
													>
														<Form.Control
															type="number"
															onChange={
																handleChange
															}
															name="mother_slavry_years"
															placeholder=""
															value={
																formState.mother_slavry_years ||
																""
															}
														/>
													</FloatingLabel>
												</Form.Group>

												<Form.Group
													as={Col}
													md="4"
													controlId="validationCustom01"
												>
													<FloatingLabel
														controlId="floatingTextarea"
														label="Is Dead ?"
														className="mb-3"
													>
														<Form.Select
															onChange={
																handleChange
															}
															name="mother_is_dead"
															placeholder=""
															value={
																formState.mother_is_dead ||
																""
															}
														>
															<option value={0}>
																No
															</option>
															<option value={1}>
																Yes
															</option>
														</Form.Select>
													</FloatingLabel>
												</Form.Group>
											</Row>
										</>
									) : (
										"Parents are independent."
									)}
									<Row>
										<Col md={12}>
											<DivideTitleComponent
												title="Spouse Information"
												className="mb-4 mt-3"
											/>
										</Col>

										{formState.marital_status_id == 1 ? <>

											<Form.Group
												as={Col}
												md="4"
												controlId="validationCustom01"
											>
												<FloatingLabel
													controlId="floatingTextarea"
													label="Spouse Name"
													className="mb-3"
												>
													<Form.Control
														type="text"
														onChange={handleChange}
														name="spouse_name"
														placeholder=""
														value={
															formState.spouse_name ||
															""
														}
													/>
												</FloatingLabel>
											</Form.Group>

											<Form.Group
												as={Col}
												md="4"
												controlId="validationCustom01"
											>
												<FloatingLabel
													controlId="floatingTextarea"
													label="Spouse CNIC"
													className="mb-3"
												>
													<Form.Control
														type="text"
														maxLength={15}
														onChange={(event) =>
															updateCnicField(
																"spouse_cnic",
																event.target.value
															)
														}
														name="spouse_cnic"
														placeholder=""
														value={
															formState.spouse_cnic ||
															""
														}
													/>
												</FloatingLabel>
											</Form.Group>

											<Form.Group
												as={Col}
												md="4"
												controlId="validationCustom01"
											>
												<FloatingLabel
													controlId="floatingTextarea"
													label="Spouse D-O-B"
													className="mb-3"
												>
													<Form.Control
														type="date"
														onChange={handleChange}
														name="spouse_dob"
														placeholder=""
														value={
															formState.spouse_dob ||
															""
														}
													/>
												</FloatingLabel>
											</Form.Group>

											<Form.Group
												as={Col}
												md="4"
												controlId="validationCustom01"
											>
												<FloatingLabel
													controlId="floatingTextarea"
													label="Slavery Years *"
													className="mb-3"
												>
													<Form.Control
														type="number"
														onChange={handleChange}
														name="spouse_slavry_year"
														placeholder=""
														value={
															formState.spouse_slavry_year ||
															""
														}
													/>
												</FloatingLabel>
											</Form.Group>

											<Form.Group
												as={Col}
												md="4"
												controlId="validationCustom01"
											>
												<FloatingLabel
													controlId="floatingTextarea"
													label="Is Dead ?"
													className="mb-3"
												>
													<Form.Select
														onChange={handleChange}
														name="spouse_is_dead"
														placeholder=""
														value={
															formState.spouse_is_dead ||
															""
														}
													>
														<option>No</option>
														<option>Yes</option>
													</Form.Select>
												</FloatingLabel>
											</Form.Group>

										</>

											:

											<p>Beneficiary is {formState.marital_status_name}.</p>}


									</Row>

									<Row>
										<Col md={12}>
											<DivideTitleComponent
												title="Kin Information"
												className="mb-4 mt-3"
											/>
										</Col>
									</Row>

									{formState.kin_list.length > 0 ?
										<>

											{formState.kin_list?.map(
												(kin, kinIndex) => (
													<Row key={kin.id || kinIndex}>
														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingSelect"
																label="Relation"
																className="mb-3"
															>
																<Form.Select
																	onChange={(e) =>
																		handleKinChange(
																			kinIndex,
																			e
																		)
																	}
																	name="relationship_id"
																	value={
																		kin.relationship_id ||
																		""
																	}
																>
																	<option value="">
																		Select Relation
																	</option>
																	{data?.relations.map(
																		(
																			relation,
																			index
																		) => (
																			<option
																				key={
																					index
																				}
																				value={
																					relation.id ||
																					""
																				}
																			>
																				{
																					relation.name
																				}
																			</option>
																		)
																	)}
																</Form.Select>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Name"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(e) =>
																		handleKinChange(
																			kinIndex,
																			e
																		)
																	}
																	name="name"
																	placeholder=""
																	value={
																		kin.name || ""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="CNIC"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(e) =>
																		handleKinChange(
																			kinIndex,
																			e
																		)
																	}
																	name="cnic"
																	maxLength={15}
																	placeholder=""
																	value={
																		kin.cnic || ""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="D-O-B"
																className="mb-3"
															>
																<Form.Control
																	type="date"
																	onChange={(e) =>
																		handleKinChange(
																			kinIndex,
																			e
																		)
																	}
																	name="dob"
																	placeholder=""
																	value={
																		kin.dob || ""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Slavery Years *"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(e) =>
																		handleKinChange(
																			kinIndex,
																			e
																		)
																	}
																	name="slavry_year"
																	placeholder=""
																	value={
																		kin.slavry_year ||
																		""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="4"
															controlId="validationCustom01"
														>
															<h4 className="mt-3">
																Kin #{kinIndex + 1}
																<i
																	title="Remove Kin"
																	className="material-icons float-end text-danger pe-auto"
																	style={{
																		cursor: "pointer",
																	}}
																	onClick={() =>
																		removeKin(
																			kinIndex
																		)
																	}
																>
																	delete
																</i>
															</h4>
														</Form.Group>
													</Row>
												)
											)}
										</>
										:

										"Beneficiary has no Kins."}


									<Row>
										<Col
											md="6"
											className="mx-auto mb-3"
										>
											<Button
												className="mt-3 bnt-sm btn-block w-100"
												variant="success"
												onClick={() => addKin()}
											>
												+ Add Kin
											</Button>
										</Col>
									</Row>
								</>
								{/* <FamilyDetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Details", childData)
                  }
                /> */}
							</FormWizard.TabContent>

							<FormWizard.TabContent
								title="Family Story"
								icon="ti-ink-pen"
							>
								<>
									<Row>
										<Form.Group
											as={Col}
											md="12"
											controlId={`story-1`}
										>
											<Form.Label>
												Family Story
											</Form.Label>
											<Form.Control
												as="textarea"
												onChange={handleChange}
												name="family_story"
												placeholder="Enter Family Story Here..."
												rows={20}
												value={
													formState.family_story || ""
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="12"
											controlId={`story-1`}
										>
											<Form.Label>
												Extra Comments
											</Form.Label>
											<Form.Control
												as="textarea"
												onChange={handleChange}
												name="extra_comments"
												placeholder="Enter Family Comments Here..."
												rows={20}
												value={
													formState.extra_comments ||
													""
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="12"
											controlId={`story-1`}
										>
											<Form.Label>
												Prayer Request
											</Form.Label>
											<Form.Control
												as="textarea"
												onChange={handleChange}
												name="prayer_request"
												placeholder="Enter Family Prayer Request Here..."
												rows={20}
												value={
													formState.prayer_request ||
													""
												}
											/>
										</Form.Group>





									</Row>

									<Row className="mt-4">

										<Col
											md={6}
											className="mb-4"
										>
											<Card>
												<Card.Body>
													<Card.Title>
														<small>Family Story Video</small>
													</Card.Title>

													<div
														style={{
															width: "100%",
															height: "150px",
															border: "1px dashed #ddd",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
															marginBottom: "10px",
															position: "relative",
															backgroundColor: "#f9f9f9",
														}}
													>
														{formState.family_story_video ? (
															<video
																width="100%"
																height="100%"
																controls
																style={{
																	objectFit: "cover",
																	borderRadius: "8px",
																}}
															>
																<source
																	src={
																		process.env
																			.REACT_APP_IMG_URL + formState.family_story_video

																	}
																	type="video/mp4"
																/>
																Your browser does not support the
																video tag.
															</video>
														) : (
															<span style={{ color: "#666" }}>
																No Video Uploaded
															</span>
														)}
													</div>
												</Card.Body>
											</Card>
										</Col>


										<Col
											md={6}
											className="mb-4"
										>
											<Card>
												<Card.Body>
													<Card.Title>
														<small>Family Story Audio</small>
													</Card.Title>

													<div
														style={{
															width: "100%",
															height: "150px",
															border: "1px dashed #ddd",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
															marginBottom: "10px",
															position: "relative",
															backgroundColor: "#f9f9f9",
														}}
													>
														{formState.family_story_audio ? (
															<audio controls>
																<source
																	src={audioUrl}
																	type="audio/mpeg"
																/>
																Your browser does not support
																the audio element.
															</audio>
														) : (
															<span style={{ color: "#666" }}>
																No Video Uploaded
															</span>
														)}
													</div>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								</>

								{/* <FamilyStory
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Story", childData)
                  }
                /> */}
							</FormWizard.TabContent>

							<FormWizard.TabContent
								title="Beneficiary Childrens"
								icon="ti-face-smile"
							>
								<>
									<Row className="mb-3">
										<Col md={5}>
											<Form.Check
												type={"checkbox"}
												id={`default-1`}
												name="is_parent_dependent"
												checked={formState.no_child} // Bind to state
												onChange={(e) =>
													setFormState({
														...formState,
														no_child:
															e.target.checked,
													})
												} // Inline change handler
												label={
													"Beneficiary Has No Child ? "
												}
											/>
										</Col>
									</Row>
									{!formState.no_child ? (
										<>
											<Row>
												<Col md={12}>
													<DivideTitleComponent
														title="Childrens Information"
														className="mb-4 mt-3"
													/>
												</Col>
											</Row>

											{formState.child.map(
												(kid, kidIndex) => (
													<Row
														key={kid.id || kidIndex}
													>
														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Name"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="name"
																	placeholder=""
																	value={
																		kid.name ||
																		""
																	}
																/>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Gender"
																className="mb-3"
															>
																<Form.Select
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="gender_id"
																	placeholder=""
																	value={
																		kid.gender_id ||
																		""
																	}
																>
																	<option>
																		Select
																	</option>
																	<option
																		value={
																			1
																		}
																	>
																		Boy
																	</option>
																	<option
																		value={
																			2
																		}
																	>
																		Girl
																	</option>
																</Form.Select>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="D-O-B"
																className="mb-3"
															>
																<Form.Control
																	type="date"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="dob"
																	placeholder=""
																	value={
																		kid.dob ||
																		""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="CNIC"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="cnic"
																	placeholder=""
																	maxLength={
																		15
																	}
																	value={
																		kid.cnic ||
																		""
																	}
																/>
															</FloatingLabel>
														</Form.Group>

														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="School Going"
																className="mb-3"
															>
																<Form.Select
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="school_going"
																	placeholder=""
																	value={
																		kid.school_going ||
																		""
																	}
																>
																	<option>
																		Select
																	</option>
																	<option
																		value={
																			1
																		}
																	>
																		{" "}
																		Yes
																	</option>
																	<option
																		value={
																			0
																		}
																	>
																		No
																	</option>
																</Form.Select>
															</FloatingLabel>
														</Form.Group>
														<Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Slavery Years *"
																className="mb-3"
															>
																<Form.Control
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="slavery_years"
																	placeholder=""
																	value={
																		kid.slavery_years ||
																		""
																	}
																/>
															</FloatingLabel>
														</Form.Group>
														{/* <Form.Group
															as={Col}
															md="3"
															controlId="validationCustom01"
														>
															<FloatingLabel
																controlId="floatingTextarea"
																label="Vocational Refer"
																className="mb-3"
															>
																<Form.Select
																	type="text"
																	onChange={(
																		e
																	) =>
																		handleKidChange(
																			kidIndex,
																			e
																		)
																	}
																	name="vocational_center"
																	placeholder=""
																	value={
																		kid.vocational_center ||
																		""
																	}
																>
																	<option>
																		Select
																	</option>
																	<option
																		value={
																			1
																		}
																	>
																		Yes
																	</option>
																	<option
																		value={
																			0
																		}
																	>
																		No
																	</option>
																</Form.Select>
															</FloatingLabel>
														</Form.Group> */}
														<Form.Group
															as={Col}
															md="2"
															controlId="validationCustom01"
														>
															<h4 className="mt-3">
																Kid #
																{kidIndex + 1}
																<i
																	title="Remove Kid"
																	className="material-icons float-end text-danger pe-auto"
																	style={{
																		cursor: "pointer",
																	}}
																	onClick={() =>
																		removeKid(
																			kidIndex
																		)
																	}
																>
																	delete
																</i>
															</h4>
														</Form.Group>
													</Row>
												)
											)}

											<Row>
												<Col
													md="6"
													className="mx-auto mb-3"
												>
													<Button
														className="mt-3 bnt-sm btn-block w-100"
														style={{
															backgroundColor:
																"#077834",
														}}
														onClick={() => addKid()}
													>
														+ Add Kid
													</Button>
												</Col>
											</Row>
										</>
									) : (
										""
									)}
								</>
								{/* <FamilyChildrens
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Family Children", childData)
                  }
                /> */}
							</FormWizard.TabContent>

							<FormWizard.TabContent
								title="Loan Details"
								icon="ti-money"
							>
								{/* <LoanDetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Loan Details", childData)
                  }
                /> */}
								<>
									<Row>
										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Select BrickKiln"
												className="mb-3"
											>
												{/* Brick Kiln List */}
												<Form.Select
													type="text"
													onChange={handleChange}
													name="brick_kiln_id"
													value={
														formState.brick_kiln_id ||
														""
													}
												>
													<option value={""}>
														Select...
													</option>
													<option value="add_new">
														Add New Brick Kiln
													</option>
													{data?.brickkilns?.map(
														(brickkiln) => (
															<option
																key={
																	brickkiln.id
																}
																value={
																	brickkiln.id ||
																	""
																}
															>
																{
																	brickkiln.brickkiln_name
																}
															</option>
														)
													)}
												</Form.Select>
												{formState.brick_kiln_id ? (
													""
												) : (
													<span className="c_error">
														Please Select BrickKiln
													</span>
												)}
											</FloatingLabel>
										</Form.Group>
										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<FloatingLabel
												controlId="floatingTextarea"
												label="Purpos of Loan"
												className="mb-3"
											>
												<Form.Select
													onChange={handleChangeLoan}
													name="loan_type_id"
													placeholder=""
													value={
														formState.loan_type_id ||
														""
													}
												>
													<option value={""}>
														Select
													</option>
													{data?.loanTypes?.map(
														(type) => {
															return (
																<option
																	key={
																		type.id
																	}
																	value={
																		type.id ||
																		""
																	}
																>
																	{type.name}
																</option>
															);
														}
													)}
												</Form.Select>
												{formState.loan_type_id ? (
													""
												) : (
													<span className="c_error">
														Please Select Loan Type
													</span>
												)}
											</FloatingLabel>
										</Form.Group>

										<Col md={6}>
											<FloatingLabel
												label="Debt Ledger"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="est_loan_amount"
													value={
														formState.est_loan_amount ||
														""
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
												{formState.est_loan_amount ? (
													""
												) : (
													<span className="c_error">
														Please Enter Loan Amount
													</span>
												)}
											</FloatingLabel>
										</Col>
										<Form.Group
											as={Col}
											md="6"
											controlId="utilityAmount"
										>
											<FloatingLabel
												label="Loan Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="loan_amount"
													value={
														formState.loan_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>
										<div className="mc-card border">

											<Col md={12} className="mb-3">
												<h4 className="my-2">Loan Images </h4>
												{formState.loan_images?.length > 0 ? (
													<div style={{ display: "flex", gap: "1rem", flexWrap: "wrap", justifyContent: "center" }}>
														{formState.loan_images.map((image, index) => {
															const imageurl = `${process.env.REACT_APP_IMG_URL}${image.img}`;
															return (
																<div
																	key={index}
																	style={{ position: "relative", width: "20rem", height: "13rem", flexShrink: 0 }}
																>
																	<img
																		src={image.preview ? image.preview : imageurl}
																		alt={`Loan ${index + 1}`}
																		style={{
																			width: "100%",
																			height: "100%",
																			borderRadius: "10px",
																			objectFit: "cover",
																			border: "2px solid #077834",
																			boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
																		}}
																		onClick={() => handleOpenImage(image, index)}
																	/>
																</div>
															);
														})}

														{openImg && (
															<Modal show={true} onHide={handleCloseImage} >
																<Modal.Header className="d-flex justify-content-between align-items-center">
																	<Button
																		variant=""
																		onClick={handleCloseImage}
																		className="btn-close"
																		style={{
																			backgroundColor: "gray"
																		}}
																	/>
																</Modal.Header>
																<Modal.Body>
																	<Form.Group>
																		<Form.Label
																			style={{
																				width: "100%",
																				textAlign: "center",
																				display: "flex",
																				flexDirection: "column",
																				alignItems: "center",
																				justifyContent: "center",
																				border: "none",
																				cursor: "pointer",
																			}}
																		>
																			{!openImg.preview && !openImg.img ? (
																				<>
																					{"Select Loan Image"}
																					<i
																						style={{ color: "#1976D2", fontSize: "4rem" }}
																						className="material-icons"
																					>
																						<FaUser />
																					</i>
																				</>
																			) : (
																				<img
																					src={openImg.preview || `${process.env.REACT_APP_IMG_URL}${openImg.img}`}
																					alt="Loan"
																					style={{
																						width: "100%",
																						maxHeight: "90vh",
																						borderRadius: "10px",
																						objectFit: "cover",
																						boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
																						border: "2px solid #077834",
																					}}
																				/>
																			)}
																			<Form.Control
																				type="file"
																				hidden
																				onChange={handleChange}
																			/>
																		</Form.Label>
																	</Form.Group>
																</Modal.Body>
																<Modal.Footer className="mb-3">
																	<Button variant="success" onClick={handleUpdateLoanImage}>
																		Update
																	</Button>
																	<Button variant="danger" onClick={handleDeleteLoanImage}>
																		Delete
																	</Button>
																</Modal.Footer>
															</Modal>
														)}
													</div>
												) : (
													<p>No loan images available</p>
												)}
											</Col>
										</div>

										<Row>
											<Col
												md={6}
												className="mb-3"
											>

												<div
													className="card"
													style={{ width: "100%" }}
												>

													<h4 className=" my-2">Unpaid Loan Invoice</h4>
													{formState.unpaid_loan_invoice?.imgsrc ? (
														<div className="card-body">
															<img
																className="card-img-top"
																src={`${process.env.REACT_APP_IMG_URL}${formState.unpaid_loan_invoice?.imgsrc}`}
																alt="Invoice image"
																style={{
																	width: "100%",
																	height: "150px",
																	cursor: "pointer",
																	display: "block",
																	margin: "0 auto",
																}}
																onClick={() => openImage(process.env.REACT_APP_IMG_URL + formState.unpaid_loan_invoice?.imgsrc)} />
														</div>
													) : (
														<div style={{ textAlign: "center" }}>
															<img
																className="nic"
																src={noImage}
																alt="No Invoice Image"
																style={{
																	width: "120px",
																	opacity: "0.7",
																	cursor: "pointer",
																	display: "block",
																	margin: "0 auto",
																}}
															/>
															<p style={{ fontSize: "0.9rem", color: "red", marginTop: "0.5rem" }}>
																No image available
															</p>
														</div>
													)}
												</div>
											</Col>

											<Col
												md={6}
												className="mb-3"
											>
												<div
													className="card"
													style={{ width: "100%" }}
												>
													<h4 className="borer my-2">Khatta Unpaid Invoice</h4>

													{formState.khatta_unpaid_file?.imgsrc ? (
														<div className="card-body">
															<img
																className="card-img-top"
																src={`process.env.REACT_APP_IMG_URL${formState.khatta_unpaid_file?.imgsrc}`}
																alt="Khatta image"
																onClick={() => openImage(process.env.REACT_APP_IMG_URL + formState.unpaid_loan_invoice?.imgsrc)}
																style={{
																	width: "100%",
																	height: "150px",
																	cursor: "pointer",
																	display: "block",
																	margin: "0 auto",
																}}

															/>
														</div>
													) : (
														<div style={{ textAlign: "center" }}>
															<img
																className="nic"
																src={noImage}
																alt="No Invoice Image"
																style={{
																	width: "120px",
																	opacity: "0.7",
																	cursor: "pointer",
																	display: "block",
																	margin: "0 auto",
																}}
															/>
															<p style={{ fontSize: "0.9rem", color: "red", marginTop: "0.5rem" }}>
																No image available
															</p>
														</div>
													)}
												</div>
											</Col>
										</Row>

										<Form.Group
											as={Col}
											md="6"
											controlId="utilityAmount"
										>
											<FloatingLabel
												label="Utility_Bill_Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="utility_amount"
													value={
														formState.utility_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>
										<Form.Group
											as={Col}
											md="6"
											controlId="medicalAmount"
										>
											<FloatingLabel
												label="Medical Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="medical_amount"
													value={
														formState.medical_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="foodRation"
										>
											<FloatingLabel
												label="Food Ration"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="food_ration"
													value={
														formState.food_ration ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="mealAmount"
										>
											<FloatingLabel
												label="Meal Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="meal_amount"
													value={
														formState.meal_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="rentAmount"
										>
											<FloatingLabel
												label="Rent Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="rent_amount"
													value={
														formState.rent_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="other"
										>
											<FloatingLabel
												label="Other loan amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="other"
													value={
														formState.other || 0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="affidavitAmount"
										>
											<FloatingLabel
												label="Affidavit Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="affidavit_amount"
													value={
														formState.affidavit_amount ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="transportationtAmount"
										>
											<FloatingLabel
												label="Transportation Amount"
												className="mb-3"
											>
												<Form.Control
													type="number"
													name="transportation"
													value={
														formState.transportation ||
														0
													}
													onChange={handleChangeLoan}
													placeholder=""
												/>
											</FloatingLabel>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												For how long you have been
												working as bonded labour on this
												brick Klin?
											</label>

											<Form.Control
												type="text"
												onChange={handleChange}
												name="working_years_on_brick_kiln"
												placeholder=""
												value={
													formState.working_years_on_brick_kiln
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												What was the first loan amount?
											</label>

											<Form.Control
												type="number"
												onChange={handleChange}
												name="first_loan_amount"
												placeholder=""
												value={
													formState.first_loan_amount
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												What was the year you took loan?
											</label>

											<Form.Control
												type="number"
												onChange={handleChange}
												name="loan_year"
												placeholder=""
												value={formState.loan_year}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												How many dependents you have?
											</label>

											<Form.Control
												type="number"
												onChange={handleChange}
												name="number_of_dependents"
												placeholder=""
												value={
													formState.number_of_dependents
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												How many members are working on
												brick kiln?
											</label>
											<Form.Control
												type="number"
												onChange={(e) => {
													const value = Number(
														e.target.value
													);
													setFormState((prev) => ({
														...prev,
														number_of_work_dependents:
															value,
														worker_list:
															Array(value).fill(
																""
															), // initialize array
													}));
												}}
												name="number_of_work_dependents"
												value={
													formState.number_of_work_dependents
												}
											/>
										</Form.Group>

										{formState.number_of_work_dependents >
											0 &&
											formState.worker_list.length < 6 &&
											Array.from({
												length: formState.number_of_work_dependents,
											}).map((_, index) => (
												<Form.Group
													as={Col}
													md="6"
													key={index}
												>
													<label>Relation</label>
													<Form.Select
														// Safe access: fallback to empty string if index does not exist
														value={
															formState
																.worker_list[
															index
															] || ""
														}
														onChange={(e) => {
															// Ensure worker_list is always an array
															const list = [
																...(formState.worker_list ||
																	[]),
															];
															list[index] =
																e.target.value; // update only this index
															setFormState(
																(prev) => ({
																	...prev,
																	worker_list:
																		list,
																})
															);
														}}
													>
														<option value="">
															choose
														</option>
														<option value="Mother">
															Mother
														</option>
														<option value="Father">
															Father
														</option>
														<option value="Spouse">
															Spouse
														</option>
														<option value="Childrens">
															Childrens
														</option>
													</Form.Select>
												</Form.Group>
											))}

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												Do your family live on the brick
												Kiln?
											</label>
											<Form.Select
												name="live_on_brick_kiln"
												value={
													formState.live_on_brick_kiln
												}
												onChange={handleChange}
											>
												<option
													value=""
													disabled
												>
													Choose
												</option>
												<option value={1}>Yes</option>
												<option value={0}>No</option>
											</Form.Select>
										</Form.Group>

										{formState.live_on_brick_kiln === 1 ? (
											<>
												<Form.Group
													as={Col}
													md="6"
													controlId="validationCustom02"
												>
													<label>
														Are you living here by
														choice?
													</label>
													<Form.Select
														name="live_by_choice"
														value={
															formState.live_by_choice
														}
														onChange={handleChange}
													>
														<option
															value=""
															disabled
														>
															Choose
														</option>
														<option value="1">
															Yes
														</option>
														<option value="0">
															No
														</option>
													</Form.Select>
												</Form.Group>

												<Form.Group
													as={Col}
													md="6"
													controlId="validationCustom03"
												>
													<label>
														What is the reason of
														you living here on the
														brick Kiln?
													</label>
													<Form.Control
														type="text"
														onChange={handleChange}
														name="reason"
														placeholder=""
														value={formState.reason}
													/>
												</Form.Group>

												<Form.Group
													as={Col}
													md="6"
													controlId="validationCustom04"
												>
													<label>
														Are you allowed to go
														and meet your relatives?
													</label>
													<Form.Select
														name="is_allow_to_meet_relatives"
														value={
															formState.is_allow_to_meet_relatives
														}
														onChange={handleChange}
													>
														<option
															value=""
															disabled
														>
															Choose
														</option>
														<option value="1">
															Yes
														</option>
														<option value="0">
															No
														</option>
													</Form.Select>
												</Form.Group>
											</>
										) : (
											<>
												<Form.Group
													as={Col}
													md="6"
													controlId="validationCustom05"
												>
													<label>
														Living Address
													</label>
													<Form.Control
														onChange={handleChange}
														name="living_address"
														placeholder=""
														value={
															formState.living_address
														}
													/>
												</Form.Group>
												<Form.Group
													as={Col}
													md="6"
													controlId="validationCustom06"
												>
													<label>
														Distance from home
													</label>
													<Form.Control
														onChange={handleChange}
														name="distance_to_home"
														placeholder=""
														value={
															formState.distance_to_home
														}
													/>
												</Form.Group>
											</>
										)}
										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												What are your normal working
												hours?
											</label>

											<Form.Control
												type="number"
												onChange={handleChange}
												name="working_hours"
												placeholder=""
												value={formState.working_hours}
											/>
										</Form.Group>
									</Row>











									<Modal
										show={show}
										onHide={handleCloseImageModal}
										onExited={() => setPreviewUrl(null)}
										centered
										size="xl"
										dialogClassName="fullscreen-modal"
									>
										<Modal.Body className="p-0 position-relative">
											<button
												type="button"
												className="btn-close position-absolute"
												style={{
													top: "1rem",
													right: "1rem",
													backgroundColor: "rgba(0,0,0,0.5)",
													borderRadius: "50%",
													padding: "0.6rem",
													filter: "invert(1)",
												}}
												onClick={handleCloseImage}
											/>

											{previewUrl ? (
												<img src={previewUrl} alt="Preview" style={{ width: "100%", height: "90vh", objectFit: "contain" }} />
											) : (
												<div className="text-center text-white ">
													<img src={noImage} alt="No image" style={{ width: "200px", opacity: "0.7", marginBottom: "1rem" }} />
													<p style={{ fontSize: "1.2rem", color: "red", backgroundColor: "transparent" }}>No image found</p>
												</div>
											)}


										</Modal.Body>
									</Modal>
								</>
							</FormWizard.TabContent>

							{/* ====================================== FEASIBILITY =============================================== */}

							<FormWizard.TabContent
								title="Feasibility Analysis"
								icon="ti-bar-chart"
							>
								{/* <LoanDetails
                  data={data}
                  updateParent={(childData) =>
                    handleChildDataUpdate("Loan Details", childData)
                  }
                /> */}
								<>
									<Row>
										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												Do you want to leave this work?
											</label>

											<Form.Select
												name="want_to_leave_work"
												value={
													formState.want_to_leave_work
												}
												onChange={handleChange}
											>
												<option
													value=""
													disabled
												>
													Choose
												</option>
												<option value={1}>Yes</option>
												<option value={0}>No</option>
											</Form.Select>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>Why?</label>

											<Form.Control
												type="text"
												onChange={handleChange}
												name="why"
												placeholder=""
												value={formState.why}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												What will you do after leaving
												this work?{" "}
											</label>

											<Form.Control
												type="text"
												onChange={handleChange}
												name="plans_after_leaving_work"
												placeholder=""
												value={
													formState.plans_after_leaving_work
												}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												Are you and your family willing
												to learn new skills and adopt
												new options?
											</label>

											<Form.Select
												name="willing_to_learn_new_skills"
												value={
													formState.willing_to_learn_new_skills
												}
												onChange={handleChange}
											>
												<option value="">Choose</option>
												<option value={1}>Yes</option>
												<option value={0}>No</option>
											</Form.Select>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												What new skills or alternative
												jobs you have in mind?{" "}
											</label>

											<Form.Control
												type="text"
												onChange={handleChange}
												name="new_skill_or_job"
												placeholder=""
												value={formState.new_skill_or_job}
											/>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												Will be you willing to send your
												children to school to study?
											</label>

											<Form.Select
												name="willing_to_educate_children"
												value={
													formState.willing_to_educate_children
												}
												onChange={handleChange}
											>
												<option
													value=""
													disabled
												>
													Choose
												</option>
												<option value={1}>Yes</option>
												<option value={0}>No</option>
											</Form.Select>
										</Form.Group>

										<Form.Group
											as={Col}
											md="6"
											controlId="validationCustom01"
										>
											<label>
												If you are facilitated in
												setting up new business,will you
												be willing to pay the principal
												cost of business in easy
												installment?
											</label>

											<Form.Select
												name="willing_to_pay_in_installments"
												value={
													formState.willing_to_pay_in_installments
												}
												onChange={handleChange}
											>
												<option
													value=""
													disabled
												>
													Choose
												</option>
												<option value={1}>Yes</option>
												<option value={0}>No</option>
											</Form.Select>
										</Form.Group>
									</Row>
								</>
							</FormWizard.TabContent>
							{
								<FormWizard.TabContent
									title="Family Gallery"
									icon="ti-gallery"
								>

									<Row>
										<div>
											{formState.rescue_date ?

												<div>

													<Row>



														{[
															{ key: "release_img", label: "Release Image", name: 'release_img' },
															{ key: "family_check_img", label: "Family Check Image", name: 'family_check_img' },
															{ key: "family_working_img", label: "Family Working Image", name: 'family_working_img' },
															{ key: "affidavit", label: "Affidavite", name: 'affidavit' },
															{ key: "new_home_img", label: "New Home Image", name: 'new_home_img' },

															{ key: "relocation_img", label: "Relocation Image", name: 'relocation_img' },


															{ key: "img_1", label: "Image 1", name: 'img_1' },
															{ key: "img_2", label: "Image 2", name: 'img_2' },
															{ key: "img_3", label: "Image 3", name: 'img_3' },
															{ key: "img_4", label: "Image 4", name: 'img_4' },
															{ key: "img_5", label: "Image 5", name: 'img_5' },
															{ key: "img_6", label: "Image 6", name: 'img_6' },
														].map(({ key, label, name }) => (
															<Col md={6} key={key}>
																<div className="mc-card border" style={{ position: "relative" }}>
																	<Form.Group>
																		<Form.Label
																			style={{
																				width: "100%",
																				textAlign: "center",
																				display: "flex",
																				flexDirection: "column",
																				alignItems: "center",
																				justifyContent: "center",
																			}}
																		>
																			{!formState[key].preview && !formState[key].imgsrc ? '' : <h4 className="my-2">{label}</h4>}                  {!formState[key].preview && !formState[key].imgsrc ? (
																				<>

																					<div className="" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "170px" }}> <h4 className="pb-3">Upload {label}</h4>
																						<i
																							style={{ color: "#1976D2", cursor: "pointer", fontSize: "4rem", padding: "4px", marginTop: "10px", opacity: "0.6" }}
																							className="material-icons"
																						>
																							<FaIdCard />
																						</i></div>

																				</>
																			) : (
																				<img
																					src={formState[key].preview || process.env.REACT_APP_IMG_URL + formState[key].imgsrc}
																					alt={label}
																					style={{
																						width: "100%",
																						height: "150px",
																						objectFit: "cover",
																						boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
																						padding: "5px",

																					}}
																				/>
																			)}
																			<Form.Control
																				type="file"
																				hidden
																				name={key}
																				onChange={(e) => uploadImages(e, "people", formState.peopleId, name)} />
																		</Form.Label>
																		{!formState[key].file && !formState[key].imgsrc && (
																			<span className="c_error d-flex align-items-center justify-content-center ">Please Upload {label}</span>
																		)}
																	</Form.Group>
																</div>
															</Col>
														))}
													</Row>
												</div>
												: 'Family not rescued'}


										</div>
									</Row>
								</FormWizard.TabContent>
							}
							{/* {
								<FormWizard.TabContent
									title="Family Business"
									icon="ti-bag"
								>

									<Row>
										<div>
											{formState.rescue_date ?

												<div>

													<Row>



														{[
															{ key: "release_img", label: "Release Image", name: 'release_img' },
															{ key: "family_check_img", label: "Family Check Image", name: 'family_check_img' },
															{ key: "family_working_img", label: "Family Working Image", name: 'family_working_img' },
															{ key: "affidavit", label: "Affidavite", name: 'affidavit' },
															{ key: "new_home_img", label: "New Home Image", name: 'new_home_img' },

															{ key: "relocation_img", label: "Relocation Image", name: 'relocation_img' },


															{ key: "img_1", label: "Image 1", name: 'img_1' },
															{ key: "img_2", label: "Image 2", name: 'img_2' },
															{ key: "img_3", label: "Image 3", name: 'img_3' },
															{ key: "img_4", label: "Image 4", name: 'img_4' },
															{ key: "img_5", label: "Image 5", name: 'img_5' },
															{ key: "img_6", label: "Image 6", name: 'img_6' },
														].map(({ key, label, name }) => (
															<Col md={6} key={key}>
																<div className="mc-card border" style={{ position: "relative" }}>
																	<Form.Group>
																		<Form.Label
																			style={{
																				width: "100%",
																				textAlign: "center",
																				display: "flex",
																				flexDirection: "column",
																				alignItems: "center",
																				justifyContent: "center",
																			}}
																		>
																			{!formState[key].preview && !formState[key].imgsrc ? '' : <h4 className="my-2">{label}</h4>}                  {!formState[key].preview && !formState[key].imgsrc ? (
																				<>

																					<div className="" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "170px" }}> <h4 className="pb-3">Upload {label}</h4>
																						<i
																							style={{ color: "#1976D2", cursor: "pointer", fontSize: "4rem", padding: "4px", marginTop: "10px", opacity: "0.6" }}
																							className="material-icons"
																						>
																							<FaIdCard />
																						</i></div>

																				</>
																			) : (
																				<img
																					src={formState[key].preview || process.env.REACT_APP_IMG_URL + formState[key].imgsrc}
																					alt={label}
																					style={{
																						width: "100%",
																						height: "150px",
																						objectFit: "cover",
																						boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
																						padding: "5px",

																					}}
																				/>
																			)}
																			<Form.Control
																				type="file"
																				hidden
																				name={key}
																				onChange={(e) => uploadImages(e, "business", formState.peopleId, name)} />
																		</Form.Label>
																		{!formState[key].file && !formState[key].imgsrc && (
																			<span className="c_error d-flex align-items-center justify-content-center ">Please Upload {label}</span>
																		)}
																	</Form.Group>
																</div>
															</Col>
														))}
													</Row>
												</div>
												: 'Family not rescued'}


										</div>
									</Row>
								</FormWizard.TabContent>
							} */}



							<FormWizard.TabContent
								title="UnderTaking"
								icon="ti-pencil-alt"
								isValid={validateTab4()}
								validationError={errorMessages}
							>
								<Row>
									<Card>
										<CardHeader>

											<strong>Undertaking:</strong> (this
											undertaking will be given by
											identifying Partner)
										</CardHeader>
										<CardBody>
											<p className="text-justify mb-40">
												{" "}
												I{" "}
												<strong className="text-underline">
													{formState.identifier?.name}
												</strong>{" "}
												with CNIC{" "}
												<strong className="text-underline">
													{formState.identifier?.cnic}
												</strong>{" "}
												herby verify that the above
												mentioned information is
												accurate to the best of my
												knowledge and I am verifying
												that this person is in dire need
												of support.
											</p>
											<Row>
												<Col md={6}>
													<strong>
														Name of Partner:
													</strong>{" "}
													{formState.identifier?.name}
												</Col>
												<Col md={6}>
													<strong>
														{" "}
														Organization:
													</strong>{" "}
													{formState.identifier?.org}
												</Col>
												<Col
													md={6}
													className="mt-3"
												>
													<strong> Cell No: </strong>
													{
														formState.identifier
															?.phone
													}
												</Col>
												<Col
													md={6}
													className="mt-3"
												>
													<strong> Signature:</strong>{" "}
													<img
														src={
															formState.identifier
																?.signature
														}
														height={50}
													/>
												</Col>
												<DivideTitleComponent
													title="Social Mobilizer"
													className="mb-4 mt-3"
												/>
												<Col md={6}>
													<strong>
														Name of Partner:
													</strong>

													<select
														onChange={(e) =>
															handleMobilizer(e)
														}
														required
														value={
															formState.mobilizer_id ||
															""
														}
														className="text-underline"
													>
														<option value={""}>
															Select...
														</option>
														{data?.identifiers?.map(
															(identifier) => (
																<option
																	key={
																		identifier.id
																	}
																	value={
																		identifier.id ||
																		""
																	}
																>
																	{
																		identifier.name
																	}
																</option>
															)
														)}
													</select>
												</Col>

												<Col md={6}>
													<strong>Signature:</strong>{" "}
													<img
														src={
															formState.mobilizer
																?.signature
														}
														height={50}
													/>
												</Col>

												<DivideTitleComponent
													title="Family Status"
													className="mb-4 mt-3"
												/>
												{/* <Col md={6}>
													<strong>Status:</strong>

													<select
														onChange={(e) =>
															handleStatus(e)
														}
														required
														value={
															formState.data_tested ||
															""
														}
														className="text-underline"
													>
														<option value={""}>
															Select...
														</option>

														<option value={1}>
															Pass
														</option>
														<option value={0}>
															Hold
														</option>
													</select>
												</Col> */}
												<Col md={12}>
													<div className="mc-divide-title my-5"></div>

													<div className="form-check">
														<input
															type="checkbox"
															className="form-check-input"
															id="undertakingCheck"
															checked={
																formState.data_tested ===
																1
															}
															onChange={(e) => {
																setFormState(
																	(prev) => ({
																		...prev,
																		data_tested:
																			e
																				.target
																				.checked
																				? 1
																				: 0,
																	})
																);
															}}
														/>
														<label
															className="form-check-label text-start ms-2"
															htmlFor="undertakingCheck"
														>
															I hereby confirm
															that the details and
															documentation
															provided for this
															family have been
															thoroughly verified.
															All loan-related
															documents have been
															accurately uploaded,
															including all
															required images and
															supporting files.
															<br />
															<strong>
																This is a tested
																and verified
																family case, and
																all the data
																submitted is
																complete and
																correct to the
																best of my
																knowledge.
															</strong>
														</label>
													</div>
												</Col>
												<Col md={12} className="mt-4">
													{!formState.data_tested && (
														<Button
															variant="danger"
															onClick={() => handleCancelFamily()}
														>
															Cancel Family
														</Button>
													)



													}

												</Col>
											</Row>
										</CardBody>
									</Card>
								</Row>
							</FormWizard.TabContent>
						</FormWizard>
						<style>{`
        @import url("https://cdn.jsdelivr.net/gh/lykmapipo/themify-icons@0.1.2/css/themify-icons.css");
      `}</style>
					</div>
				</Col>
			</Row>

			<Modal
				show={showModal}
				onHide={handleModalClose}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Add New Brick Kiln</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<StoreBrickkiln
						from={true}
						handleStoreModal={handleStoreModal}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						onClick={handleModalClose}
					>
						Cancel
					</Button>
				</Modal.Footer>
			</Modal>



		</PageLayout>
	);
}
